// ABOUTME: Chat window component for service desk ticket conversations.
// ABOUTME: Handles message grouping, rendering, and auto-scroll to bottom.

import { Box } from "@mui/material";
import ChatMessageClient from "./ChatMessageClient";
import ChatMessageFulfilmentcenter from "./ChatMessageFulfilmentcenter";

const ChatGroupItem = ({ group, viewer }) => {
    const side = group.message_type === viewer ? 'right' : 'left';
    const isInternal = group.isInternal === true;

    return (
        <Box sx={{ px: 4 }}>
            {group.message_type === 'client' && (
                <ChatMessageClient group={group} side={side} viewer={viewer} isInternal={isInternal} />
            )}
            {group.message_type === 'fulfilmentcenter' && (
                <ChatMessageFulfilmentcenter group={group} side={side} viewer={viewer} isInternal={isInternal} />
            )}
        </Box>
    );
};

export default ChatGroupItem